if (!customElements.get('product-card')) {
  class ComponentProductCard extends HTMLElement {
    constructor() {
      super()
      this.quickViewBtn = this.querySelector('.quick-view-trigger')
      this.swatches = this.querySelector('.inline-swatch-group')
      if(this.quickViewBtn)
        this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this))
      if (this.dataset.quickAddRedirect === 'true' && this.quickViewBtn) {
        this.addEventListener('click', (e)=>{
          var quickViewBtn = e.target.closest && e.target.closest('.quick-view-trigger');
          if (quickViewBtn && this.contains(quickViewBtn)) {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.redirectToProductPage();
          }
        }, true);
      }
      if(this.swatches)
        this.swatches.querySelectorAll('input').forEach((input)=>{
          input.addEventListener('change', this.onSwatchChange.bind(this))
        })

      let imageContainer = this.querySelector('.image-container');
      if (imageContainer && imageContainer.querySelector('.hover-img')) {
        let hover = false;
        this.addEventListener('mouseleave', (e)=>{
          hover && (hover=false,imageContainer.classList.remove("hover"));
        });
        this.addEventListener('mousemove', (e)=>{
          let bounds = imageContainer.getBoundingClientRect();
          if (e.y>bounds.top && e.y<bounds.bottom && e.x>bounds.left && e.x<bounds.right) {
            hover || (hover=true,imageContainer.classList.add("hover"))
          } else {
            hover && (hover=false,imageContainer.classList.remove("hover"));
          }
        });
      }
    }

    redirectToProductPage() {
      var link = this.querySelector('.product-card-url');
      var url = link ? link.getAttribute('href') : (this.quickViewBtn && this.quickViewBtn.dataset.url);
      if (url) location = url;
    }

    openQuickView(e) {
      e.preventDefault()
      if (this.dataset.quickAddRedirect === 'true') {
        this.redirectToProductPage();
        return;
      }
      $s.showLoadingOverlay();
      var qvUrl = this.quickViewBtn.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          section.dataset.source = 'default';
          window.__quickviewSource = 'default';
          var sectionProductMain = section.querySelector('.product-main-element');
          if (sectionProductMain) {
            sectionProductMain.dataset.quickviewSource = 'default';
          }
          var quickViewModal = $s.openModal(section, 'product-quick-view');
          if (quickViewModal && quickViewModal.modal) {
            quickViewModal.modal.dataset.source = 'default';
          }
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    onSwatchChange() {
      var checkedOption = this.querySelector('.inline-swatch-group input:checked')
      var variantImg = checkedOption.dataset.variantImg
      var variantUrl = checkedOption.dataset.variantUrl
      var priceFinal = checkedOption.dataset.priceFinal
      var priceCompare = checkedOption.dataset.priceCompare

      this.querySelectorAll('.product-card-url').forEach(function(e){
        e.setAttribute('href', variantUrl)
      });
      if (this.quickViewBtn)
        this.quickViewBtn.setAttribute('data-url', variantUrl)
      this.querySelector('.final').innerHTML = priceFinal
      if(this.querySelector('.from')) {
        this.querySelector('.from').style.display = "none"
      }
      if(priceCompare) {
        this.querySelector('.compare').innerHTML = priceCompare
        this.querySelector('.compare').style.display = "block"
      } else {
        this.querySelector('.compare').style.display = "none"
      }
      if(variantImg) {
        this.querySelector('.img.main').setAttribute('srcset', variantImg)
      }
    }
  }
  customElements.define('product-card', ComponentProductCard);
}
